var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.5,
    r: 10,
    fill: "#58A697"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 6.33334L12.6242 7.28334C12.709 7.30981 12.7831 7.3627 12.8357 7.43429C12.8883 7.50588 12.9167 7.59241 12.9167 7.68125V8.41667H13.75C13.8605 8.41667 13.9665 8.46057 14.0446 8.53871C14.1228 8.61685 14.1667 8.72283 14.1667 8.83334V9.66667H8.75V8.83334C8.75 8.72283 8.7939 8.61685 8.87204 8.53871C8.95018 8.46057 9.05616 8.41667 9.16667 8.41667H12.0833V7.9875L9.58333 7.20584L7.08333 7.9875V11.0725C7.08327 11.3276 7.14177 11.5793 7.25432 11.8082C7.36687 12.0371 7.53046 12.2372 7.7325 12.3929L7.81125 12.4496L9.58333 13.6583L11.1592 12.5833H9.16667C9.05616 12.5833 8.95018 12.5394 8.87204 12.4613C8.7939 12.3832 8.75 12.2772 8.75 12.1667V10.5H14.1667V12.1667C14.1667 12.2772 14.1228 12.3832 14.0446 12.4613C13.9665 12.5394 13.8605 12.5833 13.75 12.5833L12.4083 12.5838C12.2471 12.7963 12.0512 12.9838 11.825 13.1379L9.58333 14.6667L7.34167 13.1383C7.00522 12.9089 6.7299 12.6008 6.53964 12.2408C6.34939 11.8808 6.24996 11.4797 6.25 11.0725V7.68125C6.25005 7.59248 6.27845 7.50604 6.33107 7.43454C6.38368 7.36304 6.45776 7.31021 6.5425 7.28375L9.58333 6.33334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.3c6480e62c3f6a9c2d4c252fa0e8492e.svg";
export { ForwardRef as ReactComponent };